import { render, staticRenderFns } from "./IndexAnalisisPenyelia.vue?vue&type=template&id=56bf997e&scoped=true&"
import script from "./IndexAnalisisPenyelia.vue?vue&type=script&lang=js&"
export * from "./IndexAnalisisPenyelia.vue?vue&type=script&lang=js&"
import style0 from "./IndexAnalisisPenyelia.vue?vue&type=style&index=0&id=56bf997e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf997e",
  null
  
)

export default component.exports